import { SpecialtyList } from "types/Provider/Provider";

/** CLE-3002: the token an admin puts in the estimate description. */
export const DYNAMIC_DESCRIPTION_TOKEN = "dynamicDescription";
export const DYNAMIC_DESCRIPTION_PLACEHOLDER = `{{${DYNAMIC_DESCRIPTION_TOKEN}}}`;

const PARTS: { name: string; specialty: SpecialtyList }[] = [
  { name: "facility", specialty: SpecialtyList.FACILITY },
  { name: "physician", specialty: SpecialtyList.PRIMARY_PROVIDER },
  { name: "anesthesia", specialty: SpecialtyList.ANESTHESIOLOGIST },
];

const list = (parts: string[]) => {
  if (parts.length === 1) return parts[0];
  if (parts.length === 2) return `${parts[0]} and ${parts[1]}`;
  return `${parts.slice(0, -1).join(", ")}, and ${parts[parts.length - 1]}`;
};

/**
 * The sentence matched to which fees an estimate includes: facility,
 * physician (PRIMARY_PROVIDER only) and anesthesia. Other specialties and
 * amounts are ignored; nothing included returns "" (no claim to the patient).
 */
export function getDynamicEstimateDescription(
  rows?: { specialty?: string | null }[] | null
): string {
  const has = (specialty: SpecialtyList) =>
    !!rows?.some((row) => row.specialty === specialty);
  const included = PARTS.filter((part) => has(part.specialty)).map(
    (part) => part.name
  );
  if (included.length === 0) return "";
  const excluded = PARTS.map((part) => part.name).filter(
    (name) => !included.includes(name)
  );

  const first = `This estimate includes ${list(included)} fees${
    included.length === 1 ? " only" : ""
  }.`;
  if (excluded.length === 0) return first;
  const rest = list(excluded);
  return `${first} ${rest.charAt(0).toUpperCase()}${rest.slice(
    1
  )} charges, if applicable, will be billed separately.`;
}

/** What the placeholder can produce, shown on the Customize page. */
export const DYNAMIC_DESCRIPTION_EXAMPLES: string[] = [
  [{ specialty: SpecialtyList.FACILITY }],
  [
    { specialty: SpecialtyList.FACILITY },
    { specialty: SpecialtyList.PRIMARY_PROVIDER },
  ],
  [
    { specialty: SpecialtyList.FACILITY },
    { specialty: SpecialtyList.PRIMARY_PROVIDER },
    { specialty: SpecialtyList.ANESTHESIOLOGIST },
  ],
].map(getDynamicEstimateDescription);
